module.exports = __webpack_public_path__ + "img/logo.e794070d.svg";